// extracted by mini-css-extract-plugin
export var dragHelperStyleOtherBrowsers = "L2Dqt";
export var dragHelperStyleSafari = "JRB3P";